import React from 'react';
import './SocialShare.css';

const SocialShare = ({ url, title, description }) => {
    const encodedUrl = encodeURIComponent(url);
    const encodedTitle = encodeURIComponent(title);
    const encodedDescription = encodeURIComponent(description);

    const shareLinks = {
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
        twitter: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
        linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
        whatsapp: `https://wa.me/?text=${encodedTitle}%20${encodedUrl}`,
        email: `mailto:?subject=${encodedTitle}&body=${encodedDescription}%0A%0A${encodedUrl}`
    };

    const handleShare = (platform) => {
        window.open(shareLinks[platform], '_blank', 'width=600,height=400');
    };

    const handleCopyLink = () => {
        navigator.clipboard.writeText(url).then(() => {
            alert('Link copied to clipboard!');
        }).catch(err => {
            console.error('Failed to copy:', err);
        });
    };

    return (
        <div className="social-share">
            <h4>Share this</h4>
            <div className="social-share-buttons">
                <button
                    onClick={() => handleShare('facebook')}
                    className="share-btn facebook"
                    aria-label="Share on Facebook"
                >
                    <i className="fab fa-facebook-f"></i>
                </button>
                <button
                    onClick={() => handleShare('twitter')}
                    className="share-btn twitter"
                    aria-label="Share on Twitter"
                >
                    <i className="fab fa-twitter"></i>
                </button>
                <button
                    onClick={() => handleShare('linkedin')}
                    className="share-btn linkedin"
                    aria-label="Share on LinkedIn"
                >
                    <i className="fab fa-linkedin-in"></i>
                </button>
                <button
                    onClick={() => handleShare('whatsapp')}
                    className="share-btn whatsapp"
                    aria-label="Share on WhatsApp"
                >
                    <i className="fab fa-whatsapp"></i>
                </button>
                <button
                    onClick={() => handleShare('email')}
                    className="share-btn email"
                    aria-label="Share via Email"
                >
                    <i className="fas fa-envelope"></i>
                </button>
                <button
                    onClick={handleCopyLink}
                    className="share-btn copy"
                    aria-label="Copy Link"
                >
                    <i className="fas fa-link"></i>
                </button>
            </div>
        </div>
    );
};

export default SocialShare;
